import ResponseError from "../_data/models/ResponseError";
declare const fetch;

export enum CrudRouteUsages {
    CLIENT,
    API
}

export class SimpleRoute {
    static usage(): CrudRouteUsages {
        return CrudRouteUsages.CLIENT;
    }

    static baseUrl(): string {
        return this.usage() == CrudRouteUsages.CLIENT ? Api.baseUrl : Api.apiBaseUrl;
    }

    static root(): string {
        return null;
    }

    static index(): string {
        return [this.baseUrl(), this.root()].join('/');
    };
}

export default class CrudRoutes extends SimpleRoute {
    static show(id: any): string {
        return [this.index(), id].join('/');
    };

    static new(): string {
        return [this.index(), 'new'].join('/');
    };

    static edit(id: number): string {
        return [this.index(), id, 'edit'].join('/');
    };

    static create(): string {
        return this.index();
    }

    static update(id: number): string {
        return this.show(id);
    }
}

export const Api = {
    baseUrl: '/client',
    apiBaseUrl: '/v1'
};

export function apiFetch(url: string, params: {} = {}): Promise<any> {
    return fetch(url, {
        credentials: "same-origin",
        headers: {
            "ACCEPT": "application/json"
        },
        ...params
    }).then(checkStatus)
}

export function checkStatus(response: Response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        let error = new ResponseError(response.statusText);
        error.response = response;
        throw error;
    }
}


// WEBPACK FOOTER //
// ./app/client/_helpers/api.ts